import type { ContactAddress } from 'src/api/generated';
import { Avatar } from 'src/modules/shared/components/atoms/avatar';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import type { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { DropdownItem } from 'src/modules/shared/components/molecules/dropdowns/dropdown';
import { PiArrowLeft } from 'react-icons/pi';
import { getConversationHeaderAvatarText } from 'src/modules/communications/utils/conversation-detail.util';
import { ConversationHeaderActionButtons } from './conversation-header-action-buttons';
import { ConversationHeaderTitleButton } from './conversation-header-title-button';
import { TestConversationBadge } from '../../molecules/test-conversations/test-conversation-badge';

export const ConversationHeaderCompact = ({
  addresses,
  contactId,
  conversationName,
  handleCall,
  isLoading,
  isTestConversation,
  onClose,
  onOpenProfile,
  overflowItems,
  t,
}: {
  addresses?: ContactAddress[];
  contactId?: number;
  conversationName: string;
  handleCall: (phoneNumber: string) => void;
  isLoading: boolean;
  isTestConversation: boolean;
  onClose: () => void;
  onOpenProfile: (contactId: number) => void;
  overflowItems: DropdownItem[];
  t: ReturnType<typeof useI18n>['t'];
}) => (
  <div className="flex min-h-[56px] items-center gap-3">
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <Button
        variant="neutral"
        appearance="ghost"
        size="md"
        isIconOnly
        onClick={onClose}
        aria-label={t('communications.conversationHeader.backToConversations')}
      >
        <PiArrowLeft className="h-5 w-5" />
      </Button>

      <Avatar
        text={getConversationHeaderAvatarText(conversationName)}
        size="md"
        onClick={() => onOpenProfile(contactId ?? 0)}
      />

      <div className="flex min-w-0 max-w-full items-center gap-2">
        <div className="min-w-0 flex-1">
          <ConversationHeaderTitleButton
            contactId={contactId}
            conversationName={conversationName}
            onOpenProfile={onOpenProfile}
          />
        </div>
        {isTestConversation && (
          <div className="flex-shrink-0">
            <TestConversationBadge size="sm" />
          </div>
        )}
      </div>
    </div>

    <div className="flex-shrink-0">
      <ConversationHeaderActionButtons
        addresses={addresses}
        conversationName={conversationName}
        handleCall={handleCall}
        handlerSize="md"
        isLoading={isLoading}
        items={overflowItems}
        t={t}
      />
    </div>
  </div>
);
